import { createPayload } from '../utils/util.js';
import axios from './api.js';
import { APIENDPOINTS } from './ApiEndPoints/api-endpoints.js';

export const fetchUserData = async (
	page = 1,
	limit = 10,
	filter = undefined,
	search = undefined,
	sort = undefined
) => {
	filter ||= { doFilter: false };
	search ||= { doSearch: false };
	sort ||= { doSort: false };
	try {
		const url = APIENDPOINTS.DASHBOARD.usersURL;

		const response = await axios.get(url, {
			params: createPayload(page, limit, filter, search, sort)
		});
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const authDetail = async () => {
	try {
		const response = await axios.get(APIENDPOINTS.LOGIN.auth);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const sendOtp = async (token, otpId, payload) => {
	try {
		const response = await axios.post(
			APIENDPOINTS.LOGIN.sendOtp + '/' + otpId,
			payload,
			{
				headers: {
					Authorization: `Bearer ${token}`
				}
			}
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const resendOtp = async (token, otpId, payload = {}) => {
	try {
		const response = await axios.post(
			APIENDPOINTS.LOGIN.resendOtp + '/' + otpId,
			payload,
			{
				headers: {
					Authorization: `Bearer ${token}`
				}
			}
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const verifyOtp = async (token, otpId, payload = {}) => {
	try {
		const response = await axios.post(
			APIENDPOINTS.LOGIN.verifyOtp + '/' + otpId,
			payload,
			{
				headers: {
					Authorization: `Bearer ${token}`
				}
			}
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const userDropdownList = async () => {
	try {
		const response = await axios.get(APIENDPOINTS.DASHBOARD.userDropdown);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getUserLowBalanceList = async () => {
	try {
		const response = await axios.get(APIENDPOINTS.DASHBOARD.lowBalanceRoute);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const updateUserLowBalanceList = async (payload) => {
	try {
		const response = await axios.put(
			APIENDPOINTS.DASHBOARD.lowBalanceRoute,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const fetchUserDetail = async (id) => {
	try {
		const response = await axios.get(
			APIENDPOINTS.DASHBOARD.usersRole + `/${id}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const CreateUser = async (userData) => {
	try {
		const response = await axios.post(APIENDPOINTS.users, userData);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const addUserData = async (userData) => {
	try {
		const response = await axios.post(
			APIENDPOINTS?.DASHBOARD?.usersURL,
			userData
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const editUserData = async (userId, userData) => {
	try {
		const response = await axios.put(
			APIENDPOINTS?.DASHBOARD.usersURL + `/${userId}`,
			userData
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const editUserStatus = async (userId, userData) => {
	try {
		const response = await axios.put(
			APIENDPOINTS?.DASHBOARD.usersURL + `/${userId}/${userData.status}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const editProfileData = async (userData) => {
	try {
		const response = await axios.put(APIENDPOINTS?.PROFILE.uploadPic, userData);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const deleteUserdata = async (userId) => {
	try {
		const response = await axios.delete(
			APIENDPOINTS?.DASHBOARD?.usersURL + `/${userId}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const fetchbranchData = async (
	page = 1,
	limit = 100,
	filter = undefined,
	search = undefined,
	sort = undefined
) => {
	filter ||= { doFilter: false };
	search ||= { doSearch: false };
	sort ||= { doSort: false };
	try {
		const url = APIENDPOINTS.DASHBOARD.branchDetails;

		const response = await axios.get(url, {
			params: createPayload(page, limit, filter, search, sort)
		});

		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getBranchDropdownData = async () => {
	try {
		const url = APIENDPOINTS.DASHBOARD.branchDropdown;
		const response = await axios.get(url);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const downloadBranchData = async (type, filter, sorting, search) => {
	let url = APIENDPOINTS.DASHBOARD.downloadBranch + `?type=${type}`;
	if (filter?.value) {
		url += `&filterValue=${filter?.value}`;
	}

	if (filter?.column) {
		url += `&filterColumnName=${filter?.column}`;
	}

	if (search?.doSearch) {
		url += `&search=${search?.value}`;
	}

	if (sorting?.field) {
		url += `&sortingColumnName=${sorting?.field}`;
	}

	if (sorting?.type) {
		url += `&sortingType=${sorting?.type}`;
	}

	try {
		const response = await axios.get(`${url}`);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const downloadEnquiryData = async (type, filter, sorting, search) => {
	let url = APIENDPOINTS.DASHBOARD.downloadEnquiry + `?type=${type}`;
	if (filter?.value) {
		url += `&filterValue=${filter?.value}`;
	}

	if (filter?.column) {
		url += `&filterColumnName=${filter?.column}`;
	}

	if (search?.doSearch) {
		url += `&search=${search?.value}`;
	}

	if (sorting?.field) {
		url += `&sortingColumnName=${sorting?.field}`;
	}

	if (sorting?.type) {
		url += `&sortingType=${sorting?.type}`;
	}

	try {
		const response = await axios.get(url);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const downloadCustomerData = async (type, filter, sorting, search) => {
	let url = APIENDPOINTS.DASHBOARD.downloadCustomer + `?type=${type}`;
	if (filter?.value) {
		url += `&filterValue=${filter?.value}`;
	}

	if (filter?.column) {
		url += `&filterColumnName=${filter?.column}`;
	}

	if (search?.doSearch) {
		url += `&search=${search?.value}`;
	}

	if (sorting?.field) {
		url += `&sortingColumnName=${sorting?.field}`;
	}

	if (sorting?.type) {
		url += `&sortingType=${sorting?.type}`;
	}

	try {
		const response = await axios.get(url);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const downloadApprovalData = async (type, filter, sorting, search) => {
	let url = APIENDPOINTS.DASHBOARD.downloadApproval + `?type=${type}`;
	if (filter?.value) {
		url += `&filterValue=${filter?.value}`;
	}

	if (filter?.column) {
		url += `&filterColumnName=${filter?.column}`;
	}

	if (search?.doSearch) {
		url += `&search=${search?.value}`;
	}

	if (sorting?.field) {
		url += `&sortingColumnName=${sorting?.field}`;
	}

	if (sorting?.type) {
		url += `&sortingType=${sorting?.type}`;
	}

	try {
		const response = await axios.get(url);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const deshboardReportDownload = async (
	state,
	type,
	quickDateFrom,
	quickDateTo,
	filterValue,
	sortingDownlodType,
	sortingName,
	filterColumnName,
	statusFilterValue
) => {
	try {
		// Let baseURL=   axios.defaults.baseURL;
		// axios.defaults.baseURL= 'http://localhost:5004/api/';
		// axios.defaults.mode= 'no-cors';
		let url
			= APIENDPOINTS.DASHBOARD.downloadReportDocumennts
			+ `/${state}?type=${type}`;

		if (quickDateFrom) {
			url += `&quickDateFrom=${quickDateFrom}`;
		}

		if (quickDateTo) {
			url += `&quickDateTo=${quickDateTo}`;
		}

		if (filterValue) {
			url += `&filterValue=${filterValue}`;
		}

		if (filterColumnName) {
			url += `&filterColumnName=${filterColumnName}`;
		}

		if (sortingDownlodType) {
			url += `&sortingColumnName=${sortingName}`;
		}

		if (sortingName) {
			url += `&sortingType=${sortingDownlodType}`;
		}

		if (statusFilterValue) {
			url += `&statusFilterValue=${statusFilterValue}`;
		}

		const response = await axios.get(url);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const downloadEstampProcurementData = async (
	type,
	quickDateFrom,
	quickDateTo
) => {
	try {
		let url
			= APIENDPOINTS.DASHBOARD.downloadEstampProcurement + `?type=${type}`;
		if (quickDateFrom) {
			url += `&quickDateFrom=${quickDateFrom}`;
		}

		if (quickDateTo) {
			url += `&quickDateTo=${quickDateTo}`;
		}

		const response = await axios.get(url);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const downloadApprovalRequestdData = async (
	type,
	quickDateFrom,
	quickDateTo,
	filterValue,
	sortingDownlodType,
	sortingName,
	filterColumnName
) => {
	try {
		// Let baseURL=   axios.defaults.baseURL;
		// axios.defaults.baseURL= 'http://localhost:5004/api/';
		// axios.defaults.mode= 'no-cors';
		let url = APIENDPOINTS.DASHBOARD.approvalDownload + `?type=${type}`;

		if (quickDateFrom) {
			url += `&quickDateFrom=${quickDateFrom}`;
		}

		if (quickDateTo) {
			url += `&quickDateTo=${quickDateTo}`;
		}

		if (filterValue) {
			url += `&filterValue=${filterValue}`;
		}

		if (filterColumnName) {
			url += `&filterColumnName=${filterColumnName}`;
		}

		if (sortingDownlodType) {
			url += `&sortingColumnName=${sortingName}`;
		}

		if (sortingName) {
			url += `&sortingType=${sortingDownlodType}`;
		}

		const response = await axios.get(url);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const downloadBulkEsign = async (
	type,
	quickDateFrom,
	quickDateTo,
	filterValue,
	sortingDownlodType,
	sortingName,
	filterColumnName
) => {
	try {
		// Let baseURL=   axios.defaults.baseURL;
		// axios.defaults.baseURL= 'http://localhost:5004/api/';
		// axios.defaults.mode= 'no-cors';
		let url = APIENDPOINTS.DASHBOARD.bulkEsignDownload + `?type=${type}`;

		if (quickDateFrom) {
			url += `&quickDateFrom=${quickDateFrom}`;
		}

		if (quickDateTo) {
			url += `&quickDateTo=${quickDateTo}`;
		}

		if (filterValue) {
			url += `&filterValue=${filterValue}`;
		}

		if (filterColumnName) {
			url += `&filterColumnName=${filterColumnName}`;
		}

		if (sortingDownlodType) {
			url += `&sortingColumnName=${sortingName}`;
		}

		if (sortingName) {
			url += `&sortingType=${sortingDownlodType}`;
		}

		const response = await axios.get(url);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const deshboardDownload = async (
	state,
	type,
	quickDateFrom,
	quickDateTo,
	filterValue,
	sortingDownlodType,
	sortingName,
	filterColumnName
) => {
	try {
		// Let baseURL=   axios.defaults.baseURL;
		// axios.defaults.baseURL= 'http://localhost:5000/api/';
		// axios.mode= 'no-cors';
		let url
			= APIENDPOINTS.DASHBOARD.downloadDocumennts + `/${state}?type=${type}`;

		if (quickDateTo) {
			url += `&quickDateTo=${quickDateTo}`;
		}

		if (quickDateFrom) {
			url += `&quickDateFrom=${quickDateFrom}`;
		}

		if (filterValue) {
			url += `&filterValue=${filterValue}`;
		}

		if (filterColumnName) {
			url += `&filterColumnName=${filterColumnName}`;
		}

		if (sortingDownlodType) {
			url += `&sortingColumnName=${sortingName}`;
		}

		if (sortingName) {
			url += `&sortingType=${sortingDownlodType}`;
		}

		const response = await axios.get(url);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const downloadUserData = async (type, filter, sorting, search) => {
	let url = APIENDPOINTS.DASHBOARD.downloadUser + `?type=${type}`;
	if (filter?.value) {
		url += `&filterValue=${filter?.value}`;
	}

	if (filter?.column) {
		url += `&filterColumnName=${filter?.column}`;
	}

	if (search?.doSearch) {
		url += `&search=${search?.value}`;
	}

	if (sorting?.field) {
		url += `&sortingColumnName=${sorting?.field}`;
	}

	if (sorting?.type) {
		url += `&sortingType=${sorting?.type}`;
	}

	try {
		const response = await axios.get(url);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const downloadOrgData = async (type, filter, sorting, search) => {
	let url = APIENDPOINTS.DASHBOARD.downloadOrg + `?type=${type}`;
	if (filter?.value) {
		url += `&filterValue=${filter?.value}`;
	}

	if (filter?.column) {
		url += `&filterColumnName=${filter?.column}`;
	}

	if (search?.doSearch) {
		url += `&search=${search?.value}`;
	}

	if (sorting?.field) {
		url += `&sortingColumnName=${sorting?.field}`;
	}

	if (sorting?.type) {
		url += `&sortingType=${sorting?.type}`;
	}

	try {
		const response = await axios.get(url);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const downloadPartnerData = async (type, filter, sorting, search) => {
	let url = APIENDPOINTS.DASHBOARD.downloadPartner + `?type=${type}`;
	if (filter?.value) {
		url += `&filterValue=${filter?.value}`;
	}

	if (filter?.column) {
		url += `&filterColumnName=${filter?.column}`;
	}

	if (search?.doSearch) {
		url += `&search=${search?.value}`;
	}

	if (sorting?.field) {
		url += `&sortingColumnName=${sorting?.field}`;
	}

	if (sorting?.type) {
		url += `&sortingType=${sorting?.type}`;
	}

	try {
		const response = await axios.get(url);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getUamCount = async () => {
	try {
		const response = await axios.get(APIENDPOINTS.DASHBOARD.uamCount);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getBranchDataById = async (id) => {
	try {
		const response = await axios.get(
			APIENDPOINTS.DASHBOARD.branchDetails + `/${id}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const addBranchData = async (payload) => {
	try {
		const response = await axios.post(
			APIENDPOINTS.DASHBOARD.branchDetails,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const editBranchData = async (userId, userData) => {
	try {
		const response = await axios.put(
			APIENDPOINTS?.DASHBOARD?.branchDetails + `/${userId}`,
			userData
		);

		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const editBranchStatus = async (userId, userData) => {
	try {
		const response = await axios.put(
			APIENDPOINTS?.DASHBOARD?.branchDetails
				+ `/${userId}`
				+ `/${userData?.status}`
		);

		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const deleteBranchData = async (userId) => {
	try {
		const response = await axios.delete(
			APIENDPOINTS?.DASHBOARD?.branchDetails + `/${userId}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const deleteOrgData = async (orgType, orgId) => {
	try {
		const response = await axios.delete(
			APIENDPOINTS?.DASHBOARD?.organization + `/${orgType}/${orgId}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const FetchPinccode = async () => {
	try {
		const response = await axios.get(APIENDPOINTS.DASHBOARD.fetchPincode);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const userLogin = async (payload) => {
	try {
		const response = await axios.post(APIENDPOINTS.LOGIN.login, payload);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const fetchLogin = async (
	token,
	domain = 'dev.esign-proteantech.in'
) => {
	try {
		const paramStr = token
			? `?domain=${domain}&token=${token}`
			: `?domain=${domain}`;
		const response = await axios.get(APIENDPOINTS.LOGIN.login + paramStr);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const enquiryData = async (enquiryData) => {
	try {
		const response = await axios.post(
			APIENDPOINTS?.DASHBOARD?.enquiry,
			enquiryData
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const forgetPasswordData = async (forgotPasswordData) => {
	try {
		const response = await axios.post(
			APIENDPOINTS?.DASHBOARD?.forgotPassword,
			forgotPasswordData
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const validatetoken = async (token) => {
	try {
		const response = await axios.get(
			APIENDPOINTS.LOGIN.validateToken + `?token=${token}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const changePassword = async (payload) => {
	try {
		const response = await axios.put(
			APIENDPOINTS?.LOGIN?.resetPassword,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const forgotPassword = async (payload) => {
	try {
		const response = await axios.put(
			APIENDPOINTS?.LOGIN?.forgotPassword,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const addDepartment = async (payload) => {
	try {
		const response = await axios.post(
			APIENDPOINTS?.SETTING?.modifyDepartment,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getDepartment = async (
	page = 1,
	limit = 100,
	filter = undefined,
	search = undefined,
	sort = undefined
) => {
	filter ||= { doFilter: false };
	search ||= { doSearch: false };
	sort ||= { doSort: false };
	try {
		const url = APIENDPOINTS?.SETTING?.modifyDepartment;
		const response = await axios.get(url, {
			params: createPayload(page, limit, filter, search, sort)
		});

		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getDepartmentDropdown = async () => {
	try {
		const url = APIENDPOINTS.DASHBOARD.departmentDropdown;
		const response = await axios.get(url);

		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const updateDepartment = async (id, payload) => {
	try {
		const response = await axios.put(
			APIENDPOINTS?.SETTING?.modifyDepartment + `/${id}`,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const updateDepartmentStatus = async (id, payload) => {
	try {
		const response = await axios.put(
			APIENDPOINTS?.SETTING?.modifyDepartment + `/${id}/${payload.status}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const deleteDepartment = async (id) => {
	try {
		const response = await axios.delete(
			APIENDPOINTS?.SETTING?.modifyDepartment + `/${id}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const addRoles = async (payload) => {
	try {
		const response = await axios.post(APIENDPOINTS?.SETTING?.roles, payload);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getRoles = async (
	page = 1,
	limit = 100,
	filter = undefined,
	search = undefined,
	sort = undefined
) => {
	filter ||= { doFilter: false };
	search ||= { doSearch: false };
	sort ||= { doSort: false };
	try {
		const url = APIENDPOINTS?.SETTING?.roles;
		const response = await axios.get(url, {
			params: createPayload(page, limit, filter, search, sort)
		});
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getRolesDropDown = async () => {
	try {
		const url = APIENDPOINTS.DASHBOARD.rolesDropdown;
		const response = await axios.get(url);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const updateRoles = async (id, payload) => {
	try {
		const response = await axios.put(
			APIENDPOINTS?.SETTING?.roles + `/${id}`,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const updateRoleStatus = async (id, payload) => {
	try {
		const response = await axios.put(
			APIENDPOINTS?.SETTING?.roles + `/${id}/${payload.status}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const deleteRoles = async (id) => {
	try {
		const response = await axios.delete(
			APIENDPOINTS?.SETTING?.roles + `/${id}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getPermissions = async (id) => {
	try {
		const response = await axios.get(
			APIENDPOINTS?.SETTING?.allPermissions + `/${id}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const GetAllPermissions = async () => {
	try {
		const response = await axios.get(APIENDPOINTS?.SETTING?.allPermissions);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const updatePermissions = async (id, payload) => {
	try {
		const response = await axios.put(
			APIENDPOINTS?.SETTING?.allPermissions + `/${id}`,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getGrouping = async () => {
	try {
		const response = await axios.get(APIENDPOINTS?.SETTING?.grouping);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const updateGrouping = async (id, payload) => {
	try {
		const response = await axios.put(
			APIENDPOINTS?.SETTING?.grouping + `/${id}`,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getBrand = async () => {
	try {
		const response = await axios.get(APIENDPOINTS?.SETTING?.brand);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const updateBrand = async (id, payload) => {
	try {
		const response = await axios.put(
			APIENDPOINTS?.SETTING?.brand + `/${id}`,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const deleteBrand = async (id) => {
	try {
		const response = await axios.delete(
			APIENDPOINTS?.SETTING?.brand + `/${id}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getWebhook = async (type) => {
	try {
		const response = await axios.get(
			APIENDPOINTS?.SETTING?.webhook + `?isFillable=${type}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getDefaultsNotification = async () => {
	try {
		const response = await axios.get(
			APIENDPOINTS?.SETTING?.defaultsNotification
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const updateDefaultsNotification = async (payload) => {
	try {
		const response = await axios.put(
			APIENDPOINTS?.SETTING?.defaultsNotification, payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const updateWebhook = async (payload) => {
	try {
		const response = await axios.put(APIENDPOINTS?.SETTING?.webhook, payload);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const paymentGatewayAdd = async (payload) => {
	try {
		const response = await axios.put(
			APIENDPOINTS?.SETTING?.pgConfiguration,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getPaymentGateway = async (payload) => {
	try {
		const response = await axios.get(
			APIENDPOINTS?.SETTING?.pgConfiguration + `?isFillable=${payload}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};
// -----------------------------------------------------------------------
//  Template Engine API

export const fetchTemplates = async (
	page,
	limit,
	search = undefined,
	templateStatus = undefined
) => {
	const baseURL = axios.defaults.baseURL;
	try {
		const searchValue = search || undefined;
		const response = await axios.get(APIENDPOINTS.TEMPLATE_ENGINE.template, {
			params: {
				page,
				limit,
				search: searchValue,
				templateStatus
			}
		});
		axios.defaults.baseURL = baseURL;
		if (response) {
			return response;
		}
	} catch (error) {
		axios.defaults.baseURL = baseURL;
		return error?.response;
	}
};

export const checkTemplateNameAvailability = async (templateName) => {
	const baseURL = axios.defaults.baseURL;
	try {
		const response = await axios.get(
			`${APIENDPOINTS.TEMPLATE_ENGINE.templateNameAvailability}/${templateName}`
		);
		axios.defaults.baseURL = baseURL;
		if (response) {
			return response;
		}
	} catch (error) {
		axios.defaults.baseURL = baseURL;
		return error?.response;
	}
};

export const fetchTemplateById = async (templateId) => {
	try {
		if (templateId) {
			const response = await axios.get(
				APIENDPOINTS.TEMPLATE_ENGINE.template + `/${templateId}`
			);
			if (response) {
				return response;
			}
		}
	} catch (error) {
		return error?.response;
	}
};

export const deleteTemplateById = async (templateId) => {
	try {
		if (templateId) {
			const baseURL = axios.defaults.baseURL;
			const response = await axios.delete(
				APIENDPOINTS.TEMPLATE_ENGINE.template + `/${templateId}`
			);
			axios.defaults.baseURL = baseURL;
			if (response) {
				return response;
			}
		}
	} catch (error) {
		return error?.response;
	}
};

export const createTemplate = async (payload) => {
	try {
		const response = await axios.post(
			APIENDPOINTS.TEMPLATE_ENGINE.template,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const templateCopy = async (templateId, templateName) => {
	try {
		const response = await axios.post(
			APIENDPOINTS.TEMPLATE_ENGINE.copyTemplate + `/${templateId}/${templateName}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const updateTemplate = async (fileId, payload) => {
	try {
		const baseURL = axios.defaults.baseURL;
		const response = await axios.put(
			APIENDPOINTS.TEMPLATE_ENGINE.template + `/${fileId}`,
			payload
		);
		axios.defaults.baseURL = baseURL;
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const addCkAttachmentApi = async (fileId, payload) => {
	try {
		const response = await axios.post(
			APIENDPOINTS.TEMPLATE_ENGINE.template + `/${fileId}/attachment`,
			payload
		);

		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const deleteCkAttachedFile = async (fileId, attachmentId) => {
	try {
		const response = await axios.delete(
			APIENDPOINTS.TEMPLATE_ENGINE.template
				+ `/${fileId}/attachment/${attachmentId}`
		);

		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const removeAttachmentEsignAPI = async (documentId, attachmentId) => {
	try {
		const response = await axios.delete(
			APIENDPOINTS.EDITOR.esign
				+ `/step2/editor/${documentId}/attachment/${attachmentId}`
		);

		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const addDocumentSign = async (documentId, payload) => {
	const baseURL = axios.defaults.baseURL;
	try {
		delete payload.documentPdf;
		const response = await axios.put(
			APIENDPOINTS.EDITOR.esign + `/step2/editor/${documentId}`,
			payload
		);
		axios.defaults.baseURL = baseURL;
		if (response) {
			return response;
		}
	} catch (error) {
		axios.defaults.baseURL = baseURL;
		return error?.response;
	}
};

export const addCKattachmentEsignAPI = async (documentId, payload) => {
	try {
		const response = await axios.put(
			APIENDPOINTS.EDITOR.esign + `/step2/editor/${documentId}/attachment`,
			payload
		);

		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};
//  --------------------------------------------------------------------

export const AddRecipient = async (id, payload) => {
	try {
		if (!payload.isAdditionalAmountRequired) {
			delete payload.additionalAmount;
			delete payload.additionalAmountDescription;
			delete payload.additionalAmountPayeeEmail;
		}

		const response = await axios.put(
			APIENDPOINTS.NEW_ESIGN.addRecipient + `/${id}`,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const RegistrationData = async (type, payload) => {
	try {
		const response = await axios.post(
			APIENDPOINTS.REGISTRATION.registration + `/${type}`,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const registrationEditData = async (type, id = null, payload = {}) => {
	try {
		let url = APIENDPOINTS.REGISTRATION.registration + `/${type}`;
		let response = null;
		if (id) {
			url += `/${id}`;
			response = await axios.put(url, payload);
		} else {
			response = await axios.post(url, payload);
		}

		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const putOrgStatus = async (type, id = null, payload = {}) => {
	try {
		const url
			= APIENDPOINTS.REGISTRATION.registration
			+ `/${type}`
			+ `/${id}`
			+ `/${payload.status}`;

		const response = await axios.put(url);

		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const uploadOrgDocuments = async (payload) => {
	try {
		const response = await axios.post(
			APIENDPOINTS.REGISTRATION.uploadDocument,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getOrganizationDetail = async (type, id) => {
	try {
		const response = await axios.get(
			APIENDPOINTS.REGISTRATION.registration + `/${type}/${id}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const fetchEnquirydata = async (
	page = 1,
	limit = 10,
	filter = undefined,
	search = undefined,
	sort = undefined
) => {
	filter ||= { doFilter: false };
	search ||= { doSearch: false };
	sort ||= { doSort: false };
	try {
		const url = APIENDPOINTS.DASHBOARD.displayEnquiry;
		const response = await axios.get(url, {
			params: createPayload(page, limit, filter, search, sort)
		});
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const fetchApprovaldata = async (
	page = 1,
	limit = 10,
	filter = undefined,
	search = undefined,
	sort = undefined
) => {
	filter ||= { doFilter: false };
	search ||= { doSearch: false };
	sort ||= { doSort: false };
	try {
		const url = APIENDPOINTS.DASHBOARD.approvalRequests;
		const response = await axios.get(url, {
			params: createPayload(page, limit, filter, search, sort)
		});

		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const updateApprovalData = async (id, data) => {
	try {
		const response = await axios.put(
			APIENDPOINTS?.DASHBOARD?.approvalRequests + `/${id}`,
			data
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const fetchOrganizationdata = async (
	type,
	page = 1,
	limit = 10,
	filter = undefined,
	search = undefined,
	sort = undefined
) => {
	filter ||= { doFilter: false };
	search ||= { doSearch: false };
	sort ||= { doSort: false };
	try {
		const url = APIENDPOINTS.DASHBOARD.organization + `/${type}`;

		const response = await axios.get(url, {
			params: createPayload(page, limit, filter, search, sort)
		});
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const fetchOrganizationDatabyId = async (type, orgId = '') => {
	try {
		const response = await axios.get(
			APIENDPOINTS?.DASHBOARD?.organization + `/${type}/${orgId}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const ApproveOrgUser = async (id, payload) => {
	try {
		const response = await axios.put(
			APIENDPOINTS.DASHBOARD.organization + `/${id}`,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const GetState = async () => {
	try {
		const response = await axios.get(APIENDPOINTS?.NEW_ESIGN?.getState);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getDenominations = async (
	state,
	denominationAmount,
	documentId,
	articleCode
) => {
	try {
		const response = await axios.get(
			APIENDPOINTS?.NEW_ESIGN?.getDenomination
				+ `/${documentId}?state=${state}&denominationAmount=${denominationAmount}&articleCode=${articleCode}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const FetchOrganizationTypeData = async () => {
	try {
		const response = await axios.get(
			APIENDPOINTS?.REGISTRATION?.organisationType
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const fetchFileIdById = async (orgId = '', id = '') => {
	try {
		const response = await axios.get(
			APIENDPOINTS?.REGISTRATION?.fileId + `/${orgId}/${id}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const FetchSavedEsign = async (documentId) => {
	const baseURL = axios.defaults.baseURL;
	try {
		const response = await axios.get(
			APIENDPOINTS?.SAVED_ESIGN.esign + `/${documentId}`
		);
		axios.defaults.baseURL = baseURL;
		if (response) {
			return response;
		}
	} catch (error) {
		axios.defaults.baseURL = baseURL;
		return error?.response;
	}
};

export const esignUpdate = async (documentId, payload) => {
	const baseURL = axios.defaults.baseURL;
	try {
		const response = await axios.put(
			APIENDPOINTS?.SAVED_ESIGN.update + `/${documentId}`,
			payload
		);
		axios.defaults.baseURL = baseURL;
		if (response) {
			return response;
		}
	} catch (error) {
		axios.defaults.baseURL = baseURL;
		return error?.response;
	}
};

export const esignfiledata = async (documentId, step) => {
	const baseURL = axios.defaults.baseURL;
	try {
		const response = await axios.get(
			APIENDPOINTS?.SAVED_ESIGN.filedata + `/${documentId}/${step}`
		);
		axios.defaults.baseURL = baseURL;
		if (response) {
			return response;
		}
	} catch (error) {
		axios.defaults.baseURL = baseURL;
		return error?.response;
	}
};

export const getDeafultCordinate = async (documentId) => {
	const baseURL = axios.defaults.baseURL;
	try {
		const response = await axios.get(
			APIENDPOINTS?.SAVED_ESIGN.getDeafultCordinate + `/${documentId}`
		);
		axios.defaults.baseURL = baseURL;
		if (response) {
			return response;
		}
	} catch (error) {
		axios.defaults.baseURL = baseURL;
		return error?.response;
	}
};

export const esignsinglefiledata = async (documentId, filePath) => {
	const baseURL = axios.defaults.baseURL;
	try {
		const response = await axios.post(
			APIENDPOINTS?.SAVED_ESIGN.singlefiledata + `/${documentId}`,
			{ filePath }
		);
		axios.defaults.baseURL = baseURL;
		if (response) {
			return response;
		}
	} catch (error) {
		axios.defaults.baseURL = baseURL;
		return error?.response;
	}
};

export const getFinalTemplatePdf = async (documentId, payload) => {
	const baseURL = axios.defaults.baseURL;
	try {
		const response = await axios.post(
			APIENDPOINTS?.NEW_ESIGN.getFinalPDF + `/${documentId}`,
			payload
		);
		axios.defaults.baseURL = baseURL;
		if (response) {
			return response;
		}
	} catch (error) {
		axios.defaults.baseURL = baseURL;
		return error?.response;
	}
};

export const deleteSavedEsign = async (documentId) => {
	try {
		const response = await axios.delete(
			APIENDPOINTS?.SAVED_ESIGN.esign + `/${documentId}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const BrandTypeData = async () => {
	try {
		const response = await axios.get(APIENDPOINTS?.LOGIN?.brandType);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const enquirystatus = async (id, payload) => {
	try {
		const response = await axios.put(
			APIENDPOINTS.DASHBOARD.displayEnquiry + `/${id}`,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const step1 = async (payload) => {
	delete payload.templateName;
	const baseURL = axios.defaults.baseURL;
	try {
		const response = await axios.post(APIENDPOINTS?.NEW_ESIGN?.step1, payload);
		axios.defaults.baseURL = baseURL;
		if (response) {
			return response;
		}
	} catch (error) {
		axios.defaults.baseURL = baseURL;
		return error?.response;
	}
};

export const newESignsent = async (documentID) => {
	const baseURL = axios.defaults.baseURL;
	try {
		const response = await axios.put(
			APIENDPOINTS?.NEW_ESIGN?.NewESignsent + `/${documentID}`
		);
		axios.defaults.baseURL = baseURL;
		if (response) {
			return response;
		}
	} catch (error) {
		axios.defaults.baseURL = baseURL;
		return error?.response;
	}
};

export const saveStampDetails = async (documentId, payload) => {
	try {
		const response = await axios.put(
			APIENDPOINTS.NEW_ESIGN?.saveStampDetails + `/${documentId}`,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getSignCords = async (documentId, payload, remove = null) => {
	const baseURL = axios.defaults.baseURL;
	try {
		if (!documentId) {
			return payload;
		}

		let pdfdataUrl = null;
		if (payload.pdfdataUrl) {
			pdfdataUrl = payload.pdfdataUrl;
			delete payload.pdfdataUrl;
		}

		if (remove) {
			payload.remove = remove;
		}

		const response = await axios.put(
			APIENDPOINTS.NEW_ESIGN?.avalibleCoordinates,
			payload
		);
		axios.defaults.baseURL = baseURL;
		if (response) {
			if (pdfdataUrl) {
				response.pdfdataUrl = pdfdataUrl;
			}

			return response;
		}

		return payload;
	} catch (error) {
		axios.defaults.baseURL = baseURL;
		return { message: error.message };
	}
};

export const getStampPaper = async (documentId, payload) => {
	try {
		const response = await axios.get(
			APIENDPOINTS.NEW_ESIGN?.saveStampDetails + `/${documentId}`,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const blockStampPaperApi = async (documentId) => {
	try {
		const response = await axios.put(
			APIENDPOINTS.NEW_ESIGN?.getDenomination + `/${documentId}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const GetEsignDocument = async (status) => {
	try {
		const response = await axios.get(
			APIENDPOINTS?.DASHBOARD?.getEsignDocument + `?status=${status}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getSettings = async (type) => {
	try {
		const response = await axios.get(
			APIENDPOINTS?.SETTING?.setting + `/${type}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const putSettings = async (payload, type) => {
	try {
		const response = await axios.put(
			APIENDPOINTS?.SETTING?.setting + `/${type}`,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getGlobalSettings = async () => {
	try {
		const response = await axios.get(APIENDPOINTS?.SETTING?.globalSettings);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const putGlobalSettings = async (payload) => {
	try {
		const response = await axios.put(
			APIENDPOINTS?.SETTING?.globalSettings,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getConfigData = async () => {
	try {
		const response = await axios.get(APIENDPOINTS?.NEW_ESIGN?.getConfig);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getDropDownData = async (dataName) => {
	try {
		const response = await axios.get(
			APIENDPOINTS.DASHBOARD.fetchDropDowndata + `/${dataName}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const fetchMenuDetail = async () => {
	try {
		const response = await axios.get(APIENDPOINTS.LOGIN.menu);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getProfilePic = async () => {
	try {
		const response = await axios.get(APIENDPOINTS.PROFILE.uploadPic);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const updateProfilePic = async (payload) => {
	try {
		const response = await axios.put(APIENDPOINTS.PROFILE.uploadPic, payload);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const addToWallet = async (orgId, data) => {
	try {
		const response = await axios.put(
			APIENDPOINTS.WALLET_PROTEAN.getProteanWallet + `/${orgId}`,
			data
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const postExcelFile = async (payload) => {
	try {
		const response = await axios.post(APIENDPOINTS.DASHBOARD.bulk, payload, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		});
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const postExcelFileUser = async (payload) => {
	try {
		const response = await axios.post(
			APIENDPOINTS.DASHBOARD.bulkUser,
			payload,
			{
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const postPdfFileVendor = async (id, payload) => {
	try {
		const response = await axios.put(
			APIENDPOINTS.DASHBOARD.vendorUploadDoc + `/${id}`,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const postPdfFileVendorSubmit = async (id) => {
	try {
		const response = await axios.put(
			APIENDPOINTS.DASHBOARD.vendorUploadDoc + `/${id}/submit`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const approveStampVendor = async (id) => {
	try {
		const response = await axios.put(
			APIENDPOINTS.DASHBOARD.approvalRequestStampApprove + `/${id}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getAllVendorDoc = async (id) => {
	try {
		const response = await axios.get(
			APIENDPOINTS.DASHBOARD.getVendorDoc + `/${id}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const deleteVendorDoc = async (stampOrderId, stampInventoryId) => {
	try {
		const response = await axios.delete(
			APIENDPOINTS.DASHBOARD.vendorUploadDoc
				+ `/${stampOrderId}/${stampInventoryId}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const putCourierDetails = async (id, payload) => {
	try {
		const response = await axios.put(
			APIENDPOINTS.DASHBOARD.courierVendor + `/${id}`,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

// ----------------------------- Filter Dashboard and Wallet API ----------------------------------- //
const generateApiUrl = (baseApiUrl, payload) => {
	let url = `${baseApiUrl}?page=${payload.page}&limit=${payload.limit}`;

	if (payload.sortingColumnName && payload.sortingType) {
		url += `&sortingColumnName=${payload.sortingColumnName}&sortingType=${payload.sortingType}`;
	}

	if (payload.quickDateFrom && payload.quickDateTo) {
		url += `&quickDateFrom=${payload.quickDateFrom}&quickDateTo=${payload.quickDateTo}`;
	}

	if (payload.search) {
		url += `&search=${payload.search}`;
	}

	if (payload.filterValue) {
		url += `&filterValue=${payload.filterValue}`;
	}

	if (payload.filterColumnName) {
		url += `&filterColumnName=${payload.filterColumnName}`;
	}

	return url;
};

const makeApiRequest = async (endpoint, payload) => {
	try {
		let apiUrl = generateApiUrl(endpoint, payload);
		apiUrl = cleanUrl(apiUrl);
		const response = await axios.get(apiUrl);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

// Helper function to clean and encode URL correctly
const cleanUrl = (url) => {
	if (!url.includes('?')) {
		return url;
	} // If no query params, return as is

	const [baseUrl, queryString] = url.split('?');
	const params = new URLSearchParams(queryString);
	const cleanedParams = [];

	// Process each parameter
	for (const [key, value] of params.entries()) {
		if (value && value !== 'null' && value !== 'undefined') {
			// Encode `#` as `%23` manually to prevent Axios from stripping it
			const finalValue = value === '#' ? '%23' : encodeURIComponent(value);
			cleanedParams.push(`${key}=${finalValue}`);
		}
	}

	return `${baseUrl}?${cleanedParams.join('&')}`;
};

const getRequest = async (endpoint, payload, query = '') => {
	try {
		const response = await axios.get(
			endpoint + `/${payload}${query ? '?' + query : ''}`
		);
		return response;
	} catch (error) {
		return error?.response;
	}
};

const putRequest = async (endpoint, id, payload) => {
	try {
		const response = await (payload
			? axios.put(`${endpoint}/${id}`, payload)
			: axios.put(`${endpoint}/${id}`));

		return response;
	} catch (error) {
		return error?.response;
	}
};

const deleteRequest = async (endpoint, id, payload) => {
	try {
		const response = await (payload
			? axios.delete(`${endpoint}/${id}`, payload)
			: axios.delete(`${endpoint}/${id}`));

		return response;
	} catch (error) {
		return error?.response;
	}
};

// ------------------------------------------------------------------------------------------------- //
// ---------------------------------- Dashboard API ------------------------------------------------ //
export const esignDraft = async (payload) =>
	makeApiRequest(APIENDPOINTS.DASHBOARD.esignDraft, payload);

export const estampProcurement = async (payload) =>
	makeApiRequest(APIENDPOINTS.DASHBOARD.estampProcurement, payload);

export const esignAwaitingAction = async (payload) => {
	try {
		const response = await axios.get(APIENDPOINTS.DASHBOARD.esignAwaitingAction, {
			params: payload
		});
		return response;
	} catch (error) {
		return error;
	}
};

export const esignAwaitingSigning = async (payload) =>
	makeApiRequest(APIENDPOINTS.DASHBOARD.esignAwaitingSigning, payload);
export const esignSigned = async (payload) =>
	makeApiRequest(APIENDPOINTS.DASHBOARD.esignSigned, payload);
export const esignCustomerRejected = async (payload) =>
	makeApiRequest(APIENDPOINTS.DASHBOARD.esignCustomerRejected, payload);

export const digitalStampOrderRequest = async (payload) =>
	makeApiRequest(APIENDPOINTS.DASHBOARD.digitalStampOrderRequest, payload);
export const digitalStampAwaitingAproval = async (payload) =>
	makeApiRequest(APIENDPOINTS.DASHBOARD.digitalStampAwaitingApproval, payload);
export const digitalStampOrderConfirmed = async (payload) =>
	makeApiRequest(APIENDPOINTS.DASHBOARD.digitalStampOrderConfirmed, payload);
export const digitalStampOrderRejected = async (payload) =>
	makeApiRequest(APIENDPOINTS.DASHBOARD.digitalStampOrderRejected, payload);
export const digitalStampOrderInventory = async (payload) =>
	makeApiRequest(APIENDPOINTS.DASHBOARD.digitalStampOrderInventory, payload);
export const proteanStampRequest = async (payload) =>
	makeApiRequest(APIENDPOINTS.DASHBOARD.proteanStampRequest, payload);
export const proteanForwardToVendor = async (payload) =>
	makeApiRequest(APIENDPOINTS.DASHBOARD.proteanForwardToVendor, payload);
export const proteanOrder = async (payload) =>
	makeApiRequest(APIENDPOINTS.DASHBOARD.proteanOrder, payload);
export const proteanForwardToCustomers = async (payload) =>
	makeApiRequest(APIENDPOINTS.DASHBOARD.proteanForwardToCustomers, payload);
export const vendorStampRequest = async (payload) =>
	makeApiRequest(APIENDPOINTS.DASHBOARD.vendorStampRequest, payload);
export const vendorAcceptedOrder = async (payload) =>
	makeApiRequest(APIENDPOINTS.DASHBOARD.vendorAcceptedOrder, payload);
export const vendorRejectedOrder = async (payload) =>
	makeApiRequest(APIENDPOINTS.DASHBOARD.vendorRejectedOrder, payload);
export const vendorSentOrder = async (payload) =>
	makeApiRequest(APIENDPOINTS.DASHBOARD.vendorSentOrder, payload);

export const digitalStampOrderDetails = async (payload) => {
	try {
		const response = await axios.post(
			APIENDPOINTS.DASHBOARD.digitalStampOrder,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const digitalStampDemominationOrderRequest = async (payload, signal) => {
	try {
		const response = await axios.put(
			APIENDPOINTS?.DASHBOARD?.digitalStampOrder,
			payload,
			{
				signal
			}
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const digitalStampOrderGetState = async () => {
	try {
		const response = await axios.get(
			APIENDPOINTS.DASHBOARD.digitalStampOrderGetState
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const digitalStampOrderViewDetails = async (stampId) => {
	try {
		const response = await axios.get(
			APIENDPOINTS.DASHBOARD.digitalStampViewDetails + `/${stampId}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const digitalStampProteanOrderViewDetails = async (stampId) => {
	try {
		const response = await axios.get(
			APIENDPOINTS.DASHBOARD.digitalStampProteanViewDetails + `/${stampId}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const cancelProteanOrderApi = async (id) => {
	try {
		const response = await axios.put(
			APIENDPOINTS?.DASHBOARD?.cancelProteanOrder + `/${id}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const vendorOrderViewDetails = async (stampId) => {
	try {
		const response = await axios.get(
			APIENDPOINTS.DASHBOARD.vendorOrderViewDetails + `/${stampId}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const stampRejectApi = async (id, payload) => {
	try {
		const response = await axios.put(
			APIENDPOINTS.DASHBOARD.approvalRequestStampReject + `/${id}`,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const deleteDocumentId = async (documentId) =>
	deleteRequest(APIENDPOINTS.DASHBOARD.deleteDocumentId, documentId);

export const getAuditTrail = async (id) => {
	try {
		const response = await axios.get(
			APIENDPOINTS.DASHBOARD.auditTrail + `/${id}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const notifyRecipientEmail = async (DocumentId) => {
	try {
		const response = await axios.get(
			APIENDPOINTS.DASHBOARD.NotifyRecipientEmail + `/${DocumentId}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const notifyRecipientPayment = async (DocumentId) => {
	try {
		const response = await axios.put(
			APIENDPOINTS.DASHBOARD.NotifyRecipientPayment + `/${DocumentId}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const NotifyRecipientChecker = async (payload) => {
	try {
		const response = await axios.post(
			APIENDPOINTS.DASHBOARD.NotifyRecipientChecker,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const NotifyRecipientSendEmail = async (payload) => {
	try {
		const response = await axios.post(
			APIENDPOINTS.DASHBOARD.NotifyRecipientSendEmail,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const GetPendingPaymentList = async (payload) =>
	makeApiRequest(APIENDPOINTS.DASHBOARD.getPendingPaymentList, payload);

export const getUnsuccessfulWorkflowList = async (payload) => {
	try {
		const response = await axios.get(APIENDPOINTS.DASHBOARD.unsuccessfulWorkflow, {
			params: payload
		});
		return response;
	} catch (error) {
		return error;
	}
};

export const getAllDashboardDocumentCount = async (payload, params) => {
	try {
		const response = await axios.get(
			APIENDPOINTS.DASHBOARD.getDashboardCount + `/${payload}`,
			{
				params
			}
		);

		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getEstampFeedback = async (id) => {
	try {
		const response = await axios.get(
			APIENDPOINTS.DASHBOARD.estampFeedback + `${id}`
		);

		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const resendMail = async (payload) => {
	try {
		const response = await axios.put(
			APIENDPOINTS?.DASHBOARD?.resentMail + `/${payload}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

// ------------------------------------------------------------------------------------------------- //
// ------------------------------------ Wallet API ------------------------------------------------- //
export const GetProteanWalletDetails = async (payload) =>
	makeApiRequest(APIENDPOINTS.WALLET_PROTEAN.getProteanWallet, payload);
export const walletRequestTransaction = async (payload) =>
	makeApiRequest(APIENDPOINTS.WALLET_PROTEAN.requestTransaction, payload);
export const walletAccountLeadger = async (payload) =>
	makeApiRequest(APIENDPOINTS.WALLET_PROTEAN.accountLedger, payload);
export const walletTransaction = async (payload) =>
	makeApiRequest(APIENDPOINTS.WALLET_PROTEAN.transaction, payload);

export const walletESignConsumption = async (payload) =>
	makeApiRequest(APIENDPOINTS.WALLET_PROTEAN.eSignConsumption, payload);
export const walletApprovalSent = async (payload) =>
	makeApiRequest(APIENDPOINTS.WALLET_PROTEAN.approvalSent, payload);
export const walletApprovalApproved = async (payload) =>
	makeApiRequest(APIENDPOINTS.WALLET_PROTEAN.approvalApproved, payload);
export const walletApprovalRejected = async (payload) =>
	makeApiRequest(APIENDPOINTS.WALLET_PROTEAN.approvalRejected, payload);
export const walletApproval = async (payload) =>
	makeApiRequest(APIENDPOINTS.WALLET_PROTEAN.approval, payload);
export const putProteanWallet = async (payload) => {
	try {
		const baseURL = axios.defaults.baseURL;
		const response = await axios.put(
			APIENDPOINTS.WALLET_PROTEAN.putProteanWallet,
			payload
		);
		axios.defaults.baseURL = baseURL;
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const PutProteanWalletDetailsProtean = async (orgId, payload) => {
	try {
		const response = await axios.put(
			APIENDPOINTS.WALLET_PROTEAN.putProteanWallet + `/${orgId}`,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const putProteanWalletApproveApproval = async (walletTxnId) => {
	try {
		const response = await axios.put(
			APIENDPOINTS.WALLET_PROTEAN.approveApproval + `/${walletTxnId}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const putProteanWalletRejectApproval = async (walletTxnId, payload) => {
	try {
		const response = await axios.put(
			APIENDPOINTS.WALLET_PROTEAN.rejectApproval + `/${walletTxnId}`,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const walletBalance = async () => {
	try {
		const response = await axios.get(APIENDPOINTS.WALLET_PROTEAN.balance);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const walletRazorpayPayment = async (amount) => {
	try {
		const baseURL = axios.defaults.baseURL;
		const response = await axios.post(
			APIENDPOINTS.WALLET_PROTEAN.razorpayPayment,
			{ amount }
		);
		axios.defaults.baseURL = baseURL;
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const razorpayWalletTopupStatus = async (walletTxnId) => {
	try {
		const response = await axios.get(
			APIENDPOINTS.WALLET_PROTEAN.walletTopupstatus + `/${walletTxnId}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const vpaDetails = async () => {
	try {
		const baseURL = axios.defaults.baseURL;
		const response = await axios.get(APIENDPOINTS.WALLET_PROTEAN.vpaDetails);
		axios.defaults.baseURL = baseURL;
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const vpaDetailsForProtean = async (orgId) => {
	try {
		const response = await axios.get(
			APIENDPOINTS.WALLET_PROTEAN.vpaDetailsProtean + `/${orgId}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const GetFinOps = async (payload) =>
	makeApiRequest(APIENDPOINTS.WALLET_PROTEAN.finOps, payload);

export const PutStampApproveFinOps = async (payload) =>
	makeApiRequest(APIENDPOINTS.WALLET_PROTEAN.stampApproveFinOps, payload);

export const PutStampRejectFinOps = async (payload) =>
	makeApiRequest(APIENDPOINTS.WALLET_PROTEAN.stampRejectFinOps, payload);

export const GetHistoryWorkflow = async (payload) =>
	makeApiRequest(APIENDPOINTS.WALLET_PROTEAN.historyWorkflow, payload);
export const GetSmsHistory = async (payload) =>
	makeApiRequest(APIENDPOINTS.WALLET_PROTEAN.smsHistory, payload);
export const GetEmailHistory = async (payload) =>
	makeApiRequest(APIENDPOINTS.WALLET_PROTEAN.emailHistory, payload);

export const postStampApproveFinOps = async (documentId) =>
	putRequest(APIENDPOINTS.WALLET_PROTEAN.stampApproveFinOps, documentId);

export const postStampRejectFinOps = async (documentId, payload) =>
	putRequest(
		APIENDPOINTS.WALLET_PROTEAN.stampRejectFinOps,
		documentId,
		payload
	);

export const getAllDocCountHistory = async (selectedQuickDate) => {
	try {
		const response = await axios.get(
			APIENDPOINTS.WALLET_PROTEAN.getWalletHistoryTabCount
				+ `?quickDateFrom=${selectedQuickDate.quickDateFrom}&quickDateTo=${selectedQuickDate.quickDateTo}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getWalletDocCount = async (
	payload,
	{ quickDateFrom, quickDateTo }
) => {
	try {
		const response = await axios.get(
			APIENDPOINTS.WALLET_PROTEAN.getWalletDocCount
				+ `/${payload}`
				+ `?quickDateFrom=${quickDateFrom}&quickDateTo=${quickDateTo}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

// ------------------------------------------------------------------------------------------------- //
// ---------------------------------- Approval Request --------------------------------------------- //
export const GetApprovalRequest = async (payload) =>
	makeApiRequest(APIENDPOINTS.DASHBOARD.approvalRequest, payload);
export const getApprovalRequestStamp = async (payload) =>
	getRequest(APIENDPOINTS.DASHBOARD.approvalRequestStamp, payload);

export const getApprovalRequestEsign = async (payload, query = '') =>
	getRequest(`${APIENDPOINTS.DASHBOARD.approvalRequestEsign}`, payload, query);

export const postApprovalRequestStampApprove = async (documentId) =>
	putRequest(APIENDPOINTS.DASHBOARD.approvalRequestStampApprove, documentId);

export const postApprovalRequestStampReject = async (documentId, payload) =>
	putRequest(
		APIENDPOINTS.DASHBOARD.approvalRequestStampReject,
		documentId,
		payload
	);

export const PutApprovalRequestEsignApprove = async (documentId) =>
	putRequest(APIENDPOINTS.DASHBOARD.approvalRequestEsignApprove, documentId);

export const PutApprovalRequestPaymentApprove = async (documentId) =>
	putRequest(APIENDPOINTS.DASHBOARD.NotifyPayeeRecipientSendEmail, documentId);

export const PutpprovalRequestEsignReject = async (documentId, payload) =>
	putRequest(
		APIENDPOINTS.DASHBOARD.approvalRequestEsignReject,
		documentId,
		payload
	);

export const putApprovalRequestEsignAction = async (documentId, payload) => {
	try {
		const response = await axios.put(
			APIENDPOINTS.DASHBOARD.approvalRequestEsignAction + `${documentId}`,
			payload
		);
		return response;
	} catch (error) {
		return error?.response;
	}
};

export const putEditCancelEsignApprovalRequest = async (documentId) => {
	try {
		const response = await axios.put(
			APIENDPOINTS.DASHBOARD.editCancelEsignApprovalRequest + `${documentId}`
		);
		return response;
	} catch (error) {
		return error?.response;
	}
};

export const putEditCancelEsignRejectRequest = async (documentId, feedback) => {
	try {
		const response = await axios.put(
			APIENDPOINTS.DASHBOARD.editCancelEsignRejectRequest + `${documentId}`, feedback
		);
		return response;
	} catch (error) {
		return error?.response;
	}
};

// ------------------------------------------------------------------------------------------------- //

export const sendExcelFile = async (id) => {
	try {
		const response = await axios.put(APIENDPOINTS.DASHBOARD.bulk + `/${id}`);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const dashboardAcceptedWithVendorId = async (id, payload) => {
	try {
		const response = await axios.put(
			APIENDPOINTS.DASHBOARD.forwardToVendor + `/${id}`,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const sendExcelFileUser = async (id) => {
	try {
		const response = await axios.put(
			APIENDPOINTS.DASHBOARD.bulkUser + `/${id}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const vendorList = async (stampId) => {
	try {
		const response = await axios.get(
			APIENDPOINTS.DASHBOARD.vendorList + `/${stampId}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const forwardToEntityAccept = async (id) => {
	try {
		const response = await axios.put(
			APIENDPOINTS.DASHBOARD.forwardToVendor
				+ `/${id}`
				+ '/forward-to-entity'
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const forwardToEntityReject = async (id, payload) => {
	try {
		const response = await axios.put(
			APIENDPOINTS.DASHBOARD.approvalRequestStampReject
				+ `/${id}`
				+ '/forward-to-entity',
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const refreshtoken = async (payload) => {
	try {
		const response = await axios.post(APIENDPOINTS.LOGIN.refreshToken, payload);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const deleteRefreshToken = async () => {
	try {
		const response = await axios.delete(APIENDPOINTS.LOGIN.refreshToken);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const userLogout = async () => {
	try {
		const response = await axios.post(APIENDPOINTS.LOGIN.logout);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

const generateStatsApiUrl = (endPoint, payload) => {
	let url = `${endPoint}?workflowType=${payload.workFlowType}&fromDate=${payload.startDate}&toDate=${payload.endDate}`;

	if (payload.state) {
		url += `&state=${payload.state}`;
	}

	if (payload.city) {
		url += `&city=${payload.city}`;
	}

	if (payload.groupingId || payload.groupingId === 0) {
		url += `&groupingId=${payload.groupingId}`;
	}

	return url;
};

export const statisticsOverView = async (payload) => {
	try {
		const apiUrl = generateStatsApiUrl(
			APIENDPOINTS.STATISTIC_OVERVIEW.piechartWorkFlow,
			payload
		);
		const response = await axios.get(apiUrl);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

const generateSBCUrl = (endPoint, payload) => {
	let url = `${endPoint}/${payload.type}?workflowType=${payload.workflowType}`;

	if (payload.type === 'cities') {
		url += `&state=${payload.state}`;
	}

	if (payload.type === 'branches') {
		url += `&state=${payload.state}&city=${payload.city}`;
	}

	return url;
};

export const statisticsSCBDropdown = async (payload) => {
	try {
		const apiUrl = generateSBCUrl(
			APIENDPOINTS.STATISTIC_OVERVIEW.states,
			payload
		);
		const response = await axios.get(apiUrl);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const statisticsBarChart = async (type) => {
	try {
		const response = await axios.get(
			`${APIENDPOINTS.STATISTIC_OVERVIEW.barchart}?workflowType=${type}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const statisticsWorkflowPopup = async (payload) => {
	try {
		const apiUrl = generateStatsApiUrl(
			APIENDPOINTS.STATISTIC_OVERVIEW.viewPopupWorkFlow,
			payload
		);
		const response = await axios.get(apiUrl);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const statisticsWorkflowOrderPopup = async (payload) => {
	try {
		const apiUrl = generateStatsApiUrl(
			APIENDPOINTS.STATISTIC_OVERVIEW.viewPopUpOrders,
			payload
		);
		const response = await axios.get(apiUrl);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const fetchLocationFromPincode = async (pincode, signal) => {
	try {
		const response = await axios.get(
			`${APIENDPOINTS.DASHBOARD.fetchLocationByPincode}/${pincode}`,
			{ signal }
		);
		return response;
	} catch (error) {
		// Handle abort separately if needed
		if (axios.isCancel?.(error) || error.name === 'CanceledError') {
			return { name: 'CanceledError' };
		}

		return error?.response;
	}
};

/* -------------------------------------Download Excel and CVS file from wallet ------------------------------------*/
export const downloadData = async (
	endpoint,
	downloadType,
	filterValue,
	filterColumnName,
	sortingColumnName,
	sortingType,
	quickDateFrom,
	quickDateTo
) => {
	let url = `${endpoint}?type=${downloadType}&quickDateFrom=${quickDateFrom}&quickDateTo=${quickDateTo}`;
	if (filterValue) {
		url += `&filterValue=${filterValue}`;
	}

	if (filterColumnName) {
		url += `&filterColumnName=${filterColumnName}`;
	}

	if (sortingColumnName) {
		url += `&sortingColumnName=${sortingColumnName}`;
	}

	if (sortingType) {
		url += `&sortingType=${sortingType}`;
	}

	try {
		const response = await axios.get(url);
		return response;
	} catch (error) {
		return error?.response;
	}
};

export const downloadStampProcurement = async (
	downloadType,
	filterValue,
	filterColumnName,
	sortingColumnName,
	sortingType,
	quickDateFrom,
	quickDateTo
) =>
	downloadData(
		APIENDPOINTS.WALLET_PROTEAN.downloadStampProcurement,
		downloadType,
		filterValue,
		filterColumnName,
		sortingColumnName,
		sortingType,
		quickDateFrom,
		quickDateTo
	);

export const eSignConsumptionDownload = async (
	downloadType,
	filterValue,
	filterColumnName,
	sortingColumnName,
	sortingType,
	quickDateFrom,
	quickDateTo
) =>
	downloadData(
		APIENDPOINTS.WALLET_PROTEAN.ESignConsumptionDownload,
		downloadType,
		filterValue,
		filterColumnName,
		sortingColumnName,
		sortingType,
		quickDateFrom,
		quickDateTo
	);

export const downloadAccountLedgerData = async (
	type,
	filterValue,
	filterColumnName,
	sortingDownloadType,
	sortingColumnName,
	search,
	quickDateFrom,
	quickDateTo
) => {
	let url = APIENDPOINTS.WALLET_PROTEAN.accountLedgerDownload
		+ `?type=${type}&quickDateFrom=${quickDateFrom}&quickDateTo=${quickDateTo}`;

	if (filterValue) {
		url += `&filterValue=${filterValue}`;
	}

	if (filterColumnName) {
		url += `&filterColumnName=${filterColumnName}`;
	}

	if (sortingColumnName) {
		url += `&sortingColumnName=${sortingColumnName}`;
	}

	if (sortingDownloadType) {
		url += `&sortingType=${sortingDownloadType}`;
	}

	if (search) {
		url += `&search=${search}`;
	}

	try {
		const response = await axios.get(url);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const downloadRequestTransaction = async (
	type,
	filterValue,
	filterColumnName,
	sortingDownloadType,
	sortingColumnName,
	search,
	quickDateFrom,
	quickDateTo
) => {
	let url = APIENDPOINTS.WALLET_PROTEAN.requestTransactionDownload
				+ `?type=${type}&quickDateFrom=${quickDateFrom}&quickDateTo=${quickDateTo}`;
	if (filterValue) {
		url += `&filterValue=${filterValue}`;
	}

	if (filterColumnName) {
		url += `&filterColumnName=${filterColumnName}`;
	}

	if (sortingColumnName) {
		url += `&sortingColumnName=${sortingColumnName}`;
	}

	if (sortingDownloadType) {
		url += `&sortingType=${sortingDownloadType}`;
	}

	if (search) {
		url += `&search=${search}`;
	}

	try {
		const response = await axios.get(url);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const workflowDownload = async (
	type,
	filterValue,
	filterColumnName,
	sortingDownloadType,
	sortingColumnName,
	search,
	quickDateFrom,
	quickDateTo
) => {
	let url = APIENDPOINTS.WALLET_PROTEAN.workflowDownload
				+ `?type=${type}&quickDateFrom=${quickDateFrom}&quickDateTo=${quickDateTo}`;
	if (filterValue) {
		url += `&filterValue=${filterValue}`;
	}

	if (filterColumnName) {
		url += `&filterColumnName=${filterColumnName}`;
	}

	if (sortingColumnName) {
		url += `&sortingColumnName=${sortingColumnName}`;
	}

	if (sortingDownloadType) {
		url += `&sortingType=${sortingDownloadType}`;
	}

	if (search) {
		url += `&search=${search}`;
	}

	try {
		const response = await axios.get(url);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const downloadSMSHistory = async (
	type,
	filterValue,
	filterColumnName,
	sortingDownloadType,
	sortingColumnName,
	search,
	quickDateFrom,
	quickDateTo
) => {
	let url = APIENDPOINTS.WALLET_PROTEAN.smsHistory
		+ '/download'
		+ `?type=${type}&quickDateFrom=${quickDateFrom}&quickDateTo=${quickDateTo}`;

	if (filterValue) {
		url += `&filterValue=${filterValue}`;
	}

	if (filterColumnName) {
		url += `&filterColumnName=${filterColumnName}`;
	}

	if (sortingColumnName) {
		url += `&sortingColumnName=${sortingColumnName}`;
	}

	if (sortingDownloadType) {
		url += `&sortingType=${sortingDownloadType}`;
	}

	if (search) {
		url += `&search=${search}`;
	}

	try {
		const response = await axios.get(url);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const downloadEmailHistory = async (
	type,
	filterValue,
	filterColumnName,
	sortingDownloadType,
	sortingColumnName,
	search,
	quickDateFrom,
	quickDateTo
) => {
	let url = APIENDPOINTS.WALLET_PROTEAN.emailHistory
		+ '/download'
		+ `?type=${type}&quickDateFrom=${quickDateFrom}&quickDateTo=${quickDateTo}`;

	if (filterValue) {
		url += `&filterValue=${filterValue}`;
	}

	if (filterColumnName) {
		url += `&filterColumnName=${filterColumnName}`;
	}

	if (sortingColumnName) {
		url += `&sortingColumnName=${sortingColumnName}`;
	}

	if (sortingDownloadType) {
		url += `&sortingType=${sortingDownloadType}`;
	}

	if (search) {
		url += `&search=${search}`;
	}

	try {
		const response = await axios.get(url);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};
/*-----------------------------------------------------------------------------------------------------------------*/

export const smsConfigurationAdd = async (payload) => {
	try {
		const response = await axios.put(
			APIENDPOINTS.SETTING.smsConfiguration,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const smsConfigurationGet = async (type) => {
	try {
		const response = await axios.get(
			APIENDPOINTS.SETTING.smsConfiguration + `?isFillable=${type}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const emailConfigurationAdd = async (payload) => {
	try {
		const response = await axios.put(
			APIENDPOINTS.SETTING.emailConfiguration,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const emailConfigurationGet = async (type) => {
	try {
		const response = await axios.get(
			APIENDPOINTS.SETTING.emailConfiguration + `?isFillable=${type}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};
/* ------------------------------------------------- State Master --------------------------------------------------*/

export const getStateMaster = async (
	page = 1,
	limit = 100,
	filter = undefined,
	search = undefined,
	sort = undefined
) => {
	filter ||= { doFilter: false };
	search ||= { doSearch: false };
	sort ||= {};
	try {
		const url = APIENDPOINTS?.SETTING?.stateMaster + 'list';
		const response = await axios.get(url, {
			params: createPayload(page, limit, filter, search, sort)
		});
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const updateState = async (id, payload) => {
	if (Object.keys(payload).length === 1) {
		try {
			const response = await axios.put(
				APIENDPOINTS?.SETTING?.stateMaster + `state/${id}`,
				payload
			);
			if (response) {
				return response;
			}
		} catch (error) {
			return error?.response;
		}
	}

	try {
		const response = await axios.put(
			APIENDPOINTS?.SETTING?.stateMaster + `edit-state-list/${id}`,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getSingleStateDetails = async (id) => {
	try {
		const response = await axios.get(
			APIENDPOINTS?.SETTING?.stateMaster + `state/details/${id}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const downloadSampleTemplate = async (type) => {
	try {
		const response = await axios.get(
			APIENDPOINTS?.DASHBOARD?.downloadSampleTemplate + `?type=${type}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const downloadSampleTemplateWithType = async (
	type,
	stampType,
	eStampRegType
) => {
	try {
		let query = '';

		if (type) {
			query += `type=${type}&`;
		}

		if (stampType) {
			query += `stampType=${stampType}&`;
		}

		if (eStampRegType) {
			query += `eStampRegType=${eStampRegType}&`;
		}

		// Remove trailing '&' if it exists
		if (query.endsWith('&')) {
			query = query.slice(0, -1);
		}

		const response = await axios.get(
			`${APIENDPOINTS?.DASHBOARD?.downloadSampleTemplate}${query ? '?' + query : ''}`
		);

		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const downloadArticleCode = async (type, stampType) => {
	try {
		const response = await axios.get(
			APIENDPOINTS?.DASHBOARD?.downloadArticleCodes
				+ `?type=${type}&stampType=${stampType}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const downloadSampleTemplateBulkUpload = async (type) => {
	try {
		const response = await axios.get(
			APIENDPOINTS?.DASHBOARD?.downloadSampleTemplateBulkUpload,
			{
				params: {
					type
				}
			}
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const downloadTemplate = async (id, type) => {
	try {
		const response = await axios.get(
			APIENDPOINTS?.DASHBOARD?.downloadTemplate + `/${id}?type=${type}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const uploadBulkTemplate = async (payload) => {
	try {
		const response = await axios.post(
			APIENDPOINTS?.DASHBOARD?.uploadBulkTemplate,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const GetBulkTemplateStatus = async (payload) => {
	await new Promise((resolve) => setTimeout(resolve, 200));
	return makeApiRequest(APIENDPOINTS.DASHBOARD.getBulkTemplateStatus, payload);
};

// Export const GetBulkTemplateStatus = async () => {
//   try {
//     const response = await axios.get(APIENDPOINTS?.DASHBOARD?.getBulkTemplateStatus);
//     if (response) return response;
//   } catch (error) {
//     return error?.response;
//   }
// };

export const downloadBulkTemplate = async (id, type) => {
	try {
		const response = await axios.get(
			APIENDPOINTS?.DASHBOARD?.downloadBulkTemplateStatusDetails
				+ `/${id}`
				+ `?type=${type}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

/*-----------------------------------------------------------------------------------------------------------------*/

/* ------------------------------------------------ Plan Management ------------------------------------------------*/
export const addNewPlan = async (payload) => {
	try {
		const response = await axios.post(
			APIENDPOINTS?.SETTING?.planManagement,
			payload
		);

		if (response) {
			return response;
		}
	} catch (error) {
		return error.response;
	}
};

export const getAllPlanList = async (
	page,
	limit,
	filter = undefined,
	sort = undefined
) => {
	filter ||= { doFilter: false };
	sort ||= { doSort: false };
	try {
		const url = APIENDPOINTS?.SETTING?.planManagement;

		const response = await axios.get(url, {
			params: createPayload(page, limit, filter, '', sort)
		});
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getSinglePlan = async (id) => {
	try {
		const response = await axios.get(
			APIENDPOINTS?.SETTING?.planManagement + `/${id}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getAvailablePlan = async (type, id) => {
	try {
		const response = await axios.get(
			APIENDPOINTS?.SETTING?.planManagement + `/available/${type}/${id}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const GetAvailablePlanforOrganization = async () => {
	try {
		const response = await axios.get(APIENDPOINTS?.SETTING?.planManagement);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const updatePlan = async (id, payload) => {
	try {
		const response = await axios.put(
			APIENDPOINTS?.SETTING?.planManagement + `/${id}`,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const updatePlanStatus = async (id, status) => {
	try {
		const response = await axios.put(
			APIENDPOINTS?.SETTING?.status + `/${id}/${status}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const deletePlan = async (id) => {
	try {
		const response = await axios.delete(
			APIENDPOINTS?.SETTING?.planManagement + `/${id}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

/*-----------------------------------------------------------------------------------------------------------------*/

export const individualUserSignUp = async (payload) => {
	try {
		const response = await axios.post(
			APIENDPOINTS?.REGISTRATION?.individualUser + '/signup',
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const fetchIndividualUserdata = async (
	page = 1,
	limit = 10,
	filter = undefined,
	search = undefined,
	sort = undefined
) => {
	filter ||= { doFilter: false };
	search ||= { doSearch: false };
	sort ||= { doSort: false };
	try {
		const url = APIENDPOINTS?.REGISTRATION?.individualUser;
		const response = await axios.get(url, {
			params: createPayload(page, limit, filter, search, sort)
		});

		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getSingleIndividualUser = async (id) => {
	try {
		const response = await axios.get(
			APIENDPOINTS?.REGISTRATION?.individualUser + `/single/${id}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const chnageIndividualUserStatus = async (id, status) => {
	try {
		const response = await axios.put(
			APIENDPOINTS?.REGISTRATION?.individualUser + `/${id}/${status}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const updateIndividualUserData = async (id, payload) => {
	try {
		const response = await axios.put(
			APIENDPOINTS?.REGISTRATION?.individualUser + `/${id}`,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const deleteIndividualUser = async (id) => {
	try {
		const response = await axios.delete(
			APIENDPOINTS?.REGISTRATION?.individualUser + `/delete/${id}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const termsAndConditionsConfig = async (payload) => {
	try {
		const response = await axios.post(
			APIENDPOINTS?.SETTING?.termsAndConditions,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getTermsAndConditionsConfig = async () => {
	try {
		const response = await axios.get(APIENDPOINTS?.SETTING?.termsAndConditions);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const updateDefaultBranch = async (id) => {
	try {
		const response = await axios.put('/iam/v1/branch/set-default/' + id);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

/* ----------------------------------------------------SMS And Email Templates-------------------------------------------------------------*/

export const getAllSmsTemplate = async (
	page = 1,
	limit = 100,
	filter = undefined,
	search = undefined,
	sort = undefined
) => {
	filter ||= { doFilter: false };
	search ||= { doSearch: false };
	sort ||= { doSort: false };
	try {
		const url = `${APIENDPOINTS?.SETTING?.smsTemplate}/list`;

		const response = await axios.get(url, {
			params: createPayload(page, limit, filter, search, sort)
		});

		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getSingleSmsTemplate = async (id) => {
	try {
		const response = await axios.get(
			APIENDPOINTS?.SETTING?.smsTemplate + `/${id}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const addSmsTemplate = async (payload) => {
	try {
		const response = await axios.post(
			APIENDPOINTS?.SETTING?.smsTemplate,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const updateSmsTemplate = async (id, payload) => {
	try {
		const response = await axios.put(
			APIENDPOINTS?.SETTING?.smsTemplate + `/${id}`,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const updateSmsTemplateStatus = async (id, status = '') => {
	try {
		const response = await axios.put(
			APIENDPOINTS?.SETTING?.smsTemplate + `/${status}/${id}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const deleteSmsTemplate = async (id) => {
	try {
		const response = await axios.delete(
			APIENDPOINTS?.SETTING?.smsTemplate + `/${id}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getSMSTemplateNameList = async () => {
	try {
		const response = await axios.get(
			APIENDPOINTS?.SETTING?.smsTemplate + '/name/list'
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getSMSVariableList = async (payload) => {
	try {
		const response = await axios.get(
			APIENDPOINTS?.SETTING?.smsTemplate
				+ `/variable/list?templateName=${payload}&category=sms`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getAllEmailTemplate = async (
	page = 1,
	limit = 100,
	filter = undefined,
	search = undefined,
	sort = undefined
) => {
	filter ||= { doFilter: false };
	search ||= { doSearch: false };
	sort ||= { doSort: true, field: 'templateName', type: 'asc' };
	try {
		const url = `${APIENDPOINTS?.SETTING?.emailTemplate}/list`;
		const response = await axios.get(url, {
			params: createPayload(page, limit, filter, search, sort)
		});

		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getSingleEmailTemplate = async (id) => {
	try {
		const response = await axios.get(
			APIENDPOINTS?.SETTING?.emailTemplate + `/${id}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const addEmailTemplate = async (payload) => {
	try {
		const response = await axios.post(
			APIENDPOINTS?.SETTING?.emailTemplate,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const updateEmailTemplate = async (id, payload) => {
	try {
		const response = await axios.put(
			APIENDPOINTS?.SETTING?.emailTemplate + `/${id}`,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const updateEmailTemplateStatus = async (id, status = '') => {
	try {
		const response = await axios.put(
			APIENDPOINTS?.SETTING?.emailTemplate + `/${status}/${id}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const deleteEmailTemplate = async (id) => {
	try {
		const response = await axios.delete(
			APIENDPOINTS?.SETTING?.emailTemplate + `/${id}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getEmailTemplateNameList = async () => {
	try {
		const response = await axios.get(
			APIENDPOINTS?.SETTING?.emailTemplate + '/name/list'
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getEmailVariableList = async (payload) => {
	try {
		const response = await axios.get(
			APIENDPOINTS?.SETTING?.emailTemplate
				+ `/variable/list?templateName=${payload}&category=email`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};
/* ----------------------------------------------------DMS Provider-------------------------------------------------------------*/

export const getAllDmsProviderList = async (
	isFillable,
	page = 1,
	limit = 100,
	filter = undefined,
	search = undefined,
	sort = undefined
) => {
	filter ||= { doFilter: false };
	search ||= { doSearch: false };
	sort ||= { doSort: false };
	try {
		const url = APIENDPOINTS?.SETTING?.dmsProvider;

		const response = await axios.get(url, {
			params: {
				isFillable,
				...createPayload(page, limit, filter, search, sort)
			}
		});
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getDmsProviderName = async () => {
	const baseURL = axios.defaults.baseURL;
	try {
		const response = await axios.get(
			APIENDPOINTS?.SETTING?.dmsProvider + '/names'
		);
		axios.defaults.baseURL = baseURL;
		if (response) {
			return response;
		}
	} catch (error) {
		axios.defaults.baseURL = baseURL;
		return error?.response;
	}
};

export const GetSingleDmsProvider = async (id) => {
	try {
		const response = await axios.get(
			APIENDPOINTS?.SETTING?.dmsProvider + `/get/${id}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const addDmsProvider = async (payload) => {
	try {
		const response = await axios.post(
			APIENDPOINTS?.SETTING?.dmsProvider,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const updateDmsProvider = async (id, payload) => {
	try {
		const response = await axios.put(
			APIENDPOINTS?.SETTING?.dmsProvider + `/update/${id}`,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const deleteDmsProvider = async (id) => {
	try {
		const response = await axios.delete(
			APIENDPOINTS?.SETTING?.dmsProvider + `/delete/${id}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const updateDmsProviderConfig = async (payload) => {
	try {
		const response = await axios.put(
			APIENDPOINTS?.SETTING?.dmsProvider + '/update-config',
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const testDmsConnection = async (payload) => {
	try {
		const response = await axios.post(
			APIENDPOINTS?.SETTING?.dmsTestConnection,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const testSMSConnection = async (payload) => {
	try {
		const response = await axios.post(
			APIENDPOINTS?.SETTING?.smsTestConnection,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const testEmailConnection = async (payload) => {
	try {
		const response = await axios.post(
			APIENDPOINTS?.SETTING?.emailTestConnection,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const testPaymentGatewayConnection = async (payload) => {
	try {
		const response = await axios.post(
			APIENDPOINTS?.SETTING?.paymentTestConnection,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const googleAuthURL = async () => {
	try {
		const response = await axios.get(APIENDPOINTS?.LOGIN?.googleAuth);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const AzureAuthURL = async () => {
	try {
		const response = await axios.get(APIENDPOINTS?.LOGIN?.azureAuth);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getAccessTokenUsingGoogleCode = async (payload) => {
	try {
		const baseURL = axios.defaults.baseURL;
		const response = await axios.post(
			APIENDPOINTS?.LOGIN?.accessTokenUsingGoogle,
			payload
		);
		axios.defaults.baseURL = baseURL;
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getAccessTokenUsingAzureCode = async (payload) => {
	try {
		const baseURL = axios.defaults.baseURL;
		const response = await axios.post(
			APIENDPOINTS?.LOGIN?.accessTokenUsingAzure,
			payload
		);
		axios.defaults.baseURL = baseURL;
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

/* --------------------------------------------New eSign Steps-----------------------------------------------------*/

export const getSteps = async (steps, id) => {
	const baseURL = axios.defaults.baseURL;
	try {
		if (!id) {
			return;
		}

		const response = await axios.get(
			APIENDPOINTS?.NEW_ESIGN?.getSteps + `/${steps}/${id}`
		);
		axios.defaults.baseURL = baseURL;
		if (response) {
			return response;
		}
	} catch (error) {
		axios.defaults.baseURL = baseURL;
		return error?.response;
	}
};

/* --------------------------------------------Manage Org Billing Profiles And Invoices-----------------------------------------------------*/

export const groupingBranchList = async () => {
	try {
		const response = await axios.get(
			APIENDPOINTS?.WALLET_PROTEAN?.groupingBranchList
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getBillingProfilesList = async (page = 1, limit = 100) => {
	try {
		const baseURL = axios.defaults.baseURL;
		const url
			= APIENDPOINTS?.WALLET_PROTEAN?.manageBillingProfiles
			+ `?page=${page}&limit=${limit}`;
		const response = await axios.get(url);
		axios.defaults.baseURL = baseURL;
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getBillingProfileById = async (id) => {
	try {
		const response = await axios.get(
			APIENDPOINTS?.WALLET_PROTEAN?.manageBillingProfiles + `/${id}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const addBillingProfile = async (payload) => {
	try {
		const response = await axios.post(
			APIENDPOINTS?.WALLET_PROTEAN?.manageBillingProfiles,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const updateBillingProfile = async (id, payload) => {
	try {
		const response = await axios.put(
			APIENDPOINTS?.WALLET_PROTEAN?.manageBillingProfiles + `/${id}`,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const putNotificationSettingsData = async (payload) => {
	try {
		const response = await axios.put(
			APIENDPOINTS?.SETTING?.notificationSettings,
			payload
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getNotificationSettingsData = async () => {
	try {
		const response = await axios.get(
			APIENDPOINTS?.SETTING?.notificationSettings
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const updateBillingProfileStatus = async (id, status) => {
	try {
		const response = await axios.put(
			APIENDPOINTS?.WALLET_PROTEAN?.updateBillingProfiles + `/${status}/${id}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const deleteBillingProfile = async (id) => {
	try {
		const response = await axios.delete(
			APIENDPOINTS?.WALLET_PROTEAN?.manageBillingProfiles + `/${id}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const InvoicesList = async (payload) =>
	makeApiRequest(APIENDPOINTS.WALLET_PROTEAN.invoiceBill, payload);

export const getInvoiceDetail = async (id) => {
	try {
		const response = await axios.get(
			APIENDPOINTS?.WALLET_PROTEAN?.invoiceBill + `/${id}`
		);
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

// Export const getOrganizationsList = async payload =>
//   makeApiRequest(APIENDPOINTS.REGISTRATION.registration + '/Organization', payload);
export const getOrganizationsList = async (payload) => {
	try {
		// Let baseURL=   axios.defaults.baseURL;
		// axios.defaults.baseURL= 'http://localhost:5001/api/';
		const response = await axios.get(
			`${APIENDPOINTS.REGISTRATION.registration}/Organization?retrieveAll=${payload.retrieveAll}`
		);
		return response;
	} catch (error) {
		return error?.response;
	}
};

export const uploadSignature = async (payload) => {
	try {
		const response = await axios.put(
			`${APIENDPOINTS.SIGNATURE.uploadSignature}`,
			payload
		);
		return response;
	} catch (error) {
		return error?.response;
	}
};

export const deleteSignature = async () => {
	try {
		const response = await axios.delete(
			`${APIENDPOINTS.SIGNATURE.uploadSignature}`
		);
		return response;
	} catch (error) {
		return error?.response;
	}
};

export const getSignature = async () => {
	try {
		const response = await axios.get(
			`${APIENDPOINTS.SIGNATURE.uploadSignature}`
		);
		return response;
	} catch (error) {
		return error?.response;
	}
};

export const getArticleCodes = async (id) => {
	try {
		const response = await axios.get(
			`${APIENDPOINTS.ARTICLECODE.articleCode}/${id}`
		);
		return response;
	} catch (error) {
		return error?.response;
	}
};

export const getDownloadUrl = async (type, id) => {
	try {
		const response = await axios.get(
			`${APIENDPOINTS.DASHBOARD.download}/${id}?type=${type}`
		);
		return response;
	} catch (error) {
		return error?.response;
	}
};

export const getWalletDownloadUrl = async (
	tabName,
	selectedType,
	filterValue,
	filterColumnName,
	sortingDownloadType,
	sortingName,
	quickDateFrom,
	quickDateTo
) => {
	try {
		let url = `${APIENDPOINTS.WALLET_PROTEAN.download}/${tabName}?type=${selectedType}`;

		if (filterValue) {
			url += `&filterValue=${filterValue}`;
		}

		if (filterColumnName) {
			url += `&filterColumnName=${filterColumnName}`;
		}

		if (sortingName) {
			url += `&sortingColumnName=${sortingName}`;
		}

		if (sortingDownloadType) {
			url += `&sortingType=${sortingDownloadType}`;
		}

		if (quickDateFrom) {
			url += `&quickDateFrom=${quickDateFrom}`;
		}

		if (quickDateTo) {
			url += `&quickDateTo=${quickDateTo}`;
		}

		const response = await axios.get(url);
		return response;
	} catch (error) {
		return error?.response;
	}
};

export const getInventoryData = async (stateId = '', payload = {}) => {
	try {
		const response = await axios.get(
			APIENDPOINTS.INVENTORY.inventory + '/fetch',
			{
				params: {
					stateId,
					...payload
				}
			}
		);
		return response;
	} catch (error) {
		return error?.response;
	}
};

export const getStampDataById = async (stampInventoryId = '') => {
	try {
		const response = await axios.get(
			APIENDPOINTS.INVENTORY.inventory + '/' + stampInventoryId
		);
		return response;
	} catch (error) {
		return error?.response;
	}
};

export const updateInventory = async (
	type = '',
	stampInventoryId = '',
	data = {}
) => {
	try {
		const response = await axios.put(
			APIENDPOINTS.INVENTORY.inventory + '/' + type,
			{
				stampInventoryIds: [stampInventoryId],
				...data
			}
		);
		return response;
	} catch (error) {
		return error?.response;
	}
};

export const downloadInventoryData = async (payload = {}) => {
	try {
		const response = await axios.get(
			APIENDPOINTS.INVENTORY.inventory + '/download',
			{
				params: payload
			}
		);
		return response;
	} catch (error) {
		return error?.response;
	}
};

export const updateBulkInventory = async (
	type = '',
	stampInventoryIds = [],
	data = {}
) => {
	try {
		const response = await axios.put(
			APIENDPOINTS.INVENTORY.inventory + '/' + type,
			{
				stampInventoryIds,
				...data
			}
		);
		return response;
	} catch (error) {
		return error?.response;
	}
};

export const getInventoryStateName = async (stateId) => {
	try {
		const response = await axios.get(
			APIENDPOINTS.INVENTORY.state + `/${stateId}`
		);
		return response;
	} catch (error) {
		return error?.response;
	}
};

export const getAvailableStatus = async (stateId = '', denomination = '') => {
	try {
		const response = await axios.get(
			APIENDPOINTS.INVENTORY.inventoryStatus
				+ `/${stateId}`
				+ `/${denomination}`
		);
		return response;
	} catch (error) {
		return error?.response;
	}
};

export const postRetry = async (id) => {
	try {
		const response = await axios.post(
			APIENDPOINTS.DASHBOARD.estampRetry + `/${id}`
		);
		return response;
	} catch (error) {
		return error?.response;
	}
};

export const postRefund = async (id, remarks = '') => {
	try {
		const response = await axios.put(
			APIENDPOINTS.DASHBOARD.estampRefund + `/${id}`,
			{ remarks }
		);
		return response;
	} catch (error) {
		return error?.response;
	}
};

export const getStampAmount = async (data) => {
	try {
		const response = await axios.get(`${APIENDPOINTS.DASHBOARD.stampAmount}/${data?.stateId}/${data.considerationPrice}/${data.articleCode}`);
		return response;
	} catch (error) {
		return error?.response;
	}
};

export const postOrgConfig = async (id, data) => {
	try {
		const response = await axios.put(
			APIENDPOINTS.DASHBOARD.OrgConfig + `/${id}`,
			data
		);
		return response;
	} catch (error) {
		return error?.response;
	}
};

export const getOrgConfig = async (id) => {
	try {
		const response = await axios.get(
			APIENDPOINTS.DASHBOARD.OrgConfig + `/${id}`
		);
		return response;
	} catch (error) {
		return error?.response;
	}
};

export const getArticleCodesByType = async (stateId = '', type = '') => {
	try {
		const response = await axios.get(
			APIENDPOINTS.NEW_ESIGN.articleCodes + `/${stateId}/${type}`
		);
		return response;
	} catch (error) {
		return error?.response;
	}
};

export const getDenomination = async (stateId = '', type = '') => {
	try {
		const response = await axios.get(
			APIENDPOINTS.NEW_ESIGN.denomination + `/${stateId}/${type}`
		);
		return response;
	} catch (error) {
		return error?.response;
	}
};

export const testMail = async (payload = {}) => {
	try {
		const response = await axios.post(APIENDPOINTS.TESTING.mail, payload);
		return response;
	} catch (error) {
		return error?.response;
	}
};

export const testLocation = async (payload = {}) => {
	try {
		const response = await axios.get(APIENDPOINTS.TESTING.location, {
			params: payload
		});
		return response;
	} catch (error) {
		return error?.response;
	}
};

export const updateRedirectLinks = async (payload = {}) => {
	try {
		const response = await axios.put(APIENDPOINTS.SETTING.redirectUrl, payload);
		return response;
	} catch (error) {
		return error?.response;
	}
};

export const getRedirectLinks = async () => {
	try {
		const response = await axios.get(APIENDPOINTS.SETTING.redirectUrl);
		return response;
	} catch (error) {
		return error?.response;
	}
};

export const getVendorDocFile = async (stampInventoryId = '') => {
	try {
		const response = await axios.get(
			APIENDPOINTS.DASHBOARD.getVendorDocFile + `/${stampInventoryId}`
		);
		return response;
	} catch (error) {
		return error?.response;
	}
};

export const getDocument = async (stampOrderId = '', pageNumber = '') => {
	try {
		const response = await axios.get(
			APIENDPOINTS.DASHBOARD.digitalStampDocument
				+ `/${stampOrderId}/page/${pageNumber}`
		);
		return response;
	} catch (error) {
		return error?.response;
	}
};

export const cancelEsignFlow = async (documentId = '', payload = {}) => {
	try {
		const response = await axios.put(
			APIENDPOINTS.NEW_ESIGN.cancelDocument + `/${documentId}/cancel`,
			payload
		);
		return response;
	} catch (error) {
		return error;
	}
};

export const getRecipientData = async (documentId = '') => {
	try {
		const response = await axios.get(
			APIENDPOINTS.NEW_ESIGN.recipientData + `/${documentId}`
		);
		return response;
	} catch (error) {
		return error;
	}
};

export const editRecipientById = async (recipientId = '', payload = {}) => {
	try {
		const response = await axios.put(
			APIENDPOINTS.NEW_ESIGN.editRecipient + `/${recipientId}`,
			payload
		);
		return response;
	} catch (error) {
		return error;
	}
};

export const getSecuritySettings = async () => {
	try {
		const response = await axios.get(APIENDPOINTS.SETTING.securitySetting);
		return response;
	} catch (error) {
		return error;
	}
};

export const putSecuritySettings = async (payload) => {
	try {
		const response = await axios.put(
			APIENDPOINTS.SETTING.securitySetting,
			payload
		);
		return response;
	} catch (error) {
		return error;
	}
};

export const getPincodeDetailsById = async (pincodeId) => {
	try {
		const response = await axios.get(APIENDPOINTS.DASHBOARD.pincodeData + `/${pincodeId}`);
		return response;
	} catch (error) {
		return error;
	}
};

export const getDashboardData = async (endpoint, params) => {
	try {
		const response = await axios.get(endpoint, {
			params
		});
		return response;
	} catch (error) {
		return error;
	}
};

export const approvalRejected = async (params) => {
	try {
		const response = await axios.get(APIENDPOINTS.DASHBOARD.approvalRejected, {
			params
		});
		return response;
	} catch (error) {
		return error;
	}
};

export const approvalSent = async (params) => {
	try {
		const response = await axios.get(APIENDPOINTS.DASHBOARD.approvalSent, {
			params
		});
		return response;
	} catch (error) {
		return error;
	}
};

export const downloadIndividualDashboardData = async (documentState, type, params = {}) => {
	try {
		const url = APIENDPOINTS.DASHBOARD.individualDownload + `/${documentState}?type=${type}`;
		const response = await axios.get(url, {
			params
		});
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const approvalApproved = async (params = {}) => {
	try {
		const url = APIENDPOINTS.DASHBOARD.approvalApproved;
		const response = await axios.get(url, {
			params
		});
		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getIndividualDashboardCount = async (payload, params) => {
	try {
		const response = await axios.get(
			APIENDPOINTS.DASHBOARD.getIndividualDashboardCount + `/${payload}`,
			{
				params
			}
		);

		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getDocumentRedirectURL = async (documentId = '') => {
	try {
		const response = await axios.get(
			APIENDPOINTS.DASHBOARD.redirectURL + `/${documentId}`
		);

		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const initiateRefund = async (documentId = '', payload = {}) => {
	try {
		const response = await axios.put(
			APIENDPOINTS.DASHBOARD.refund + `/${documentId}`, payload
		);

		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getValidationFailedData = async (documentId = '') => {
	try {
		const response = await axios.get(
			APIENDPOINTS.DASHBOARD.viewEditHistory + `/${documentId}`
		);

		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getComparisionData = async (recipientId = '') => {
	try {
		const response = await axios.get(
			APIENDPOINTS.DASHBOARD.comparisionData + `/${recipientId}`
		);

		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};

export const getDocumentData = async (documentId = '') => {
	try {
		const response = await axios.get(
			APIENDPOINTS.DASHBOARD.viewDocumentData + `/${documentId}`
		);

		if (response) {
			return response;
		}
	} catch (error) {
		return error?.response;
	}
};
